import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const CREATE_QUERY = print(gql`
  mutation CreateTag($data: CreateTagInput!) {
    createTag(data: $data) {
      id
    }
  }
`);

export interface CreateGql {
  createTag: {
    id: number;
  };
}
